import * as Validator from "yup"
import { checkFileSize, checkFileTypes } from "@sembark-travel/ui-form"

export const acceptedImageTypes = ["image/png", "image/jpeg"]

export function imageFileValidator(requiredMessage?: string) {
	const image = Validator.mixed()
		.test(
			"type-is-correct",
			"Please select a png/jpeg image file",
			checkFileTypes(acceptedImageTypes)
		)
		.test(
			"size-not-big",
			"Please select a file that is less than 1 MB in size",
			checkFileSize(1000)
		)
	return requiredMessage ? image.required(requiredMessage) : image
}
